export type XPath = string;
export type XPathCondition = XPath;

/**
 * Utility functions for manipulating / interrogating XPath strings
 */
export class XPathUtils {
  /**
   * Whether or not the xpath is absolute (i.e. starts with a forward slash)
   * @param xpath the XPath to check
   *
   * @returns true is the path is absolute; false otherwise
   */
  static isAbsolute(xpath: XPath): boolean {
    return xpath?.startsWith('/');
  }

  /**
   * Converts the XPath string into an array of parts.
   * @param xpath the XPath to split (e.g. /a/b/c)
   *
   * @returns the parts of the XPath (e.g. ['a', 'b', 'c']) or empty if there are no parts
   */
  static toArray(xpath: XPath): string[] {
    let array = xpath?.split('/');
    if (XPathUtils.isAbsolute(xpath)) {
      array = array.slice(1);
    } // strip off first element as it's empty string
    return array ?? [];
  }
}
